import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://birzkopscvuvruzsukxo.supabase.co'

const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpcnprb3BzY3Z1dnJ1enN1a3hvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY1ODcwNzcsImV4cCI6MjA4MjE2MzA3N30.VjGqhdX3rthgiULhw1YKG3S0cKQbc136onmGsvR9ffk'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'supabase.auth.token',
    flowType: 'pkce'
  },
  global: {
    headers: {
      'x-application-name': 'casapresta'
    }
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})